/**
 * Loads the 'google-libphonenumber' library dynamically
 * This is a large dependency (~550KB) and should only be loaded when needed
 */
async function loadGoogleLibPhoneNumber() {
  const GoogleLibPhoneNumber = await import('google-libphonenumber');
  const phoneUtil = GoogleLibPhoneNumber.PhoneNumberUtil.getInstance();
  return {
    GoogleLibPhoneNumber,
    phoneUtil
  };
}

/**
 * Validates a phone number for the given iso region code
 * @param {string} phoneNumber
 * @param {string} region
 * @returns boolean
 */
async function validatePhoneNumberForRegion(phoneNumber, region) {
  const {
    phoneUtil
  } = await loadGoogleLibPhoneNumber();
  const phoneNumberObj = phoneUtil.parseAndKeepRawInput(phoneNumber, region);
  return phoneUtil.isValidNumberForRegion(phoneNumberObj, region);
}
export { loadGoogleLibPhoneNumber, validatePhoneNumberForRegion };